var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoesntMatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 519,
    viewBox: "0 0 519 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.888 486.563H276.326V519.001H243.888V486.563Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.888 421.686H276.326V454.124H243.888V421.686Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2228 28.8795L93.0318 4.86981L237.984 136.523L216.175 160.533L71.2228 28.8795Z",
    fill: "#4DD0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7 113.532C72.7447 113.532 65.4789 106.266 65.4789 97.311V0H162.794C171.745 0 179.011 7.26574 179.011 16.2172C179.011 25.1726 171.745 32.4383 162.794 32.4383H97.9172V97.311C97.9172 106.266 90.6515 113.532 81.7 113.532Z",
    fill: "#80DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.326 389.252H243.888V186.939L425.406 5.40051L448.339 28.3489L276.326 200.366V389.252Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.514 113.532C429.558 113.532 422.292 106.266 422.292 97.311V32.4383H357.42C348.464 32.4383 341.199 25.1726 341.199 16.2172C341.199 7.26574 348.464 0 357.42 0H454.731V97.311C454.731 106.266 447.465 113.532 438.514 113.532Z",
    fill: "#42A5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 519,
    height: 519,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoesntMatter);
export default __webpack_public_path__ + "static/media/doesnt-matter.f51829b55a84ef681c0a1b04bb008a59.svg";
export { ForwardRef as ReactComponent };